import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';

export default function ClassesLayout() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-base)', color: 'var(--text-primary)' }}>
      <nav style={{
        background: 'var(--bg-surface)',
        borderBottom: '1px solid var(--border)',
        padding: '0.85rem 2rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1.5rem',
      }}>
        <NavLink to="/classes" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none', color: 'var(--text-primary)' }}>
          <img src="/DNA_Icon-primary.png" alt="logo" style={{ width: 26, height: 26, objectFit: 'contain' }} />
          <span style={{ fontWeight: 700, fontSize: '1rem' }}>NeuroDNA</span>
        </NavLink>
        <span style={{ color: 'var(--border)', fontSize: '1.2rem' }}>/</span>
        <NavLink to="/classes" style={{ color: 'var(--accent)', textDecoration: 'none', fontSize: '0.95rem' }}>
          Clases
        </NavLink>
      </nav>
      <main style={{ padding: '2.5rem 2rem', maxWidth: 960, margin: '0 auto' }}>
        <Outlet />
      </main>
    </div>
  );
}
